import React, { Component } from 'react';
import { Form, FormGroup, Input, Modal, Alert } from 'reactstrap';
import myFetchWithId from './myFetch';

export class CreateItem extends Component {
  constructor(props) {
    super(props);
    this.toggleNameSet = this.toggleNameSet.bind(this);
    this.setGroupName = this.setGroupName.bind(this);
    this.create = this.create.bind(this);

    this.state = {
      nameOpen: false,
      groupName: '',
      emptyAlert: false
    }
  }
  toggleNameSet() {
    this.setState(prevState => ({nameOpen: !prevState.nameOpen}));
  }
  setGroupName(e) {
    this.setState({groupName: e.target.value});
  }
  create() {
    if (this.state.groupName==='') {
      this.setState({emptyAlert: true});
    }
    else {
      const normalFetch = myFetchWithId('', true, true);
      const name = encodeURIComponent(this.state.groupName);
      try {
        normalFetch(this.props.apiCall, {name: name})
        .then( data => {
          this.setState({
            nameOpen: false,
            emptyAlert:false,
            groupName: ''
          })
          this.props.fetchItem();
          // try{
          //   console.log(name)
          //   this.props.addSelect(name)
          // }
          // catch(err){
          //   console.log('addSelect not finde' + err)
          // }
        })
      } catch (err) {
          this.props.updateError(err);
      }
    }
  }
  render() {
    return (
      <React.Fragment>
        {this.props.children({toggleNameSet: this.toggleNameSet})}
        <Modal size='sm' isOpen={this.state.nameOpen} toggle={this.toggleNameSet}>
          <div className="popup-modal">
            <div className="popup-modal-header">
              <h3>{this.props.contentText}</h3>
            </div>
            <div className="popup-modal-content">
              <Form>
                <FormGroup>
                  {this.state.emptyAlert === true
                    ?	<Alert color="danger">名稱不可為空白</Alert> : null
                  }
                  <Input type="text" id="widgetName" value={this.state.groupName} onChange={this.setGroupName}/>
                </FormGroup>
              </Form>
              <div className="popup-modal-buttonset">
                <button className="cancel" onClick={this.toggleNameSet}>
                  取消
                </button>
                <button className="apply" onClick={this.create}>
                  建立
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}


export class UpdateItem extends Component {
  constructor(props) {
    super(props);
    this.toggleRename = this.toggleRename.bind(this);
    this.rename = this.rename.bind(this);
    this.update = this.update.bind(this);

    this.state = {
      renameOpen: false,
      emptyAlert: false,
      targetId: '',
      currName: ''
    }
  }
  toggleRename(id, name) {
    const decodeName = decodeURIComponent(name);
    this.setState(prevState => ({ renameOpen:!prevState.renameOpen, targetId: id, currName: decodeName}));
  }
  rename(event) {
    this.setState({ currName: event.target.value});
  }
  update() {
    const normalFetch = myFetchWithId('', true, true);
    const updatedName = this.props.notEncodeName ? this.state.currName : encodeURIComponent(this.state.currName);
    const idToSave = this.state.targetId;
    if (this.state.currName.length > 0) {
      try {
        normalFetch(this.props.apiCall, {name: updatedName, id: idToSave})
        .then( data => {
          this.setState({
            currName: updatedName,
            emptyAlert: false,
            renameOpen: false
          })
          this.props.fetchItem();
        })
      } catch (err) {
          this.props.updateError(err);
      }
    } else {
      this.setState({emptyAlert: true});
    }
  }
  render() {
    return(
      <React.Fragment>
        {this.props.children({toggleRename: this.toggleRename})}
        <Modal size='sm' isOpen={this.state.renameOpen} toggle={this.toggleRename}>
          <div className="popup-modal">
            <div className="popup-modal-header">
              <h3>{this.props.contentText}</h3>
            </div>
            <div className="popup-modal-content">
              {this.state.emptyAlert === true
                ?	<Alert color="danger">名稱不可為空白</Alert> : null
              }
              <Input type="text" id="widgetName" value={this.state.currName} onChange={this.rename}/>
              <div className="popup-modal-buttonset">
                <button className="cancel" onClick={this.toggleRename}>
                  取消
                </button>
                <button className="apply" onClick={this.update}>
                  重新命名
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}


export class DeleteItem extends Component {
  constructor(props) {
    super(props);
    this.toggleDelete = this.toggleDelete.bind(this);
    this.delete = this.delete.bind(this);

    this.state = {
      deleteAlertOpen: false,
      currId: '',
      currName: ''
    }
  }
  toggleDelete(id, name) {
    try{
      const decodeName = decodeURIComponent(name);
      this.setState(prevState => ({ deleteAlertOpen:!prevState.deleteAlertOpen, currId: id, currName: decodeName}));
    }catch (e) {
      const decodeName = decodeURIComponent(name.replace(/%/g,'%25'));
      this.setState(prevState => ({ deleteAlertOpen:!prevState.deleteAlertOpen, currId: id, currName: decodeName}));
    }
}

  delete() {
    const id = this.state.currId;
    const deletedName = this.props.notDecodeName ? this.state.currName : decodeURIComponent(this.state.currName.replace(/%/g,'%25'));
    // const deletedName = this.props.notDecodeName ? this.state.currName : this.state.currName.replace(/%/g,'%25');

    const normalFetch = myFetchWithId('', true, true);
    try {
      normalFetch(this.props.apiCall, {id: id})
        .then( data => {
          console.log('delete author @@@@@', data);
              this.setState({
                deleteAlertOpen: false,
                currId: '',
                currName: deletedName
              });
              this.props.setInit();
              this.props.fetchItem();
            })
    } catch (err) {
        this.props.updateError(err);
        this.setState({deleteAlertOpen: false});
    }
  }
  render() {
    return(
      <React.Fragment>
        {this.props.children({toggleDelete: this.toggleDelete})}
        <Modal size='sm' isOpen={this.state.deleteAlertOpen} toggle={this.toggleDelete}>
          <div className="popup-modal">
            <div className="popup-modal-content">
            您確定要刪除 <span className='keyword-highlight'>{this.state.currName}</span> 嗎?              
            <div className="popup-modal-buttonset">
                <button className="cancel" onClick={this.toggleDelete}>
                  取消
                </button>
                <button className="delete" onClick={this.delete}>
                  刪除
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/helpers/crud.js